import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/login";
import Ponto from "./pages/ponto";

function PrivateRoute({ children }) {
  const user = localStorage.getItem("usuario");

  return user ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <Ponto />
            </PrivateRoute>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}
